class HeroController {
  constructor() {
    this.name = 'hero';
  }
}

export default HeroController;



// WEBPACK FOOTER //
// ./client/app/common/hero/hero.controller.js